import COLORS from '@web-ui-kit/colors'
import SPACES from '@web-ui-kit/spaces'
import { styled } from 'styled-components'

export const Container = styled.aside`
  background-color: ${COLORS.WHITE};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${SPACES.L};
  height: 100%;
  padding: ${SPACES.M} 0;
  width: 13.5rem;
  position: fixed;
  z-index: 19;
  & svg {
    flex-shrink: 0;
  }
`
export const CloseButtonIconContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: flex-end;
  padding: 0 ${SPACES.S} ${SPACES.S};
  width: 100%;
`

export const Content = styled.nav`
  display: flex;
  flex-direction: column;
  gap: ${SPACES.L};
  height: 100%;
  justify-content: space-between;
  padding: 0 ${SPACES.XS};
`

export const OptionsList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${SPACES.S};
`

export const Divider = styled.div`
  background-color: ${COLORS.NEUTRAL_200};
  height: 0.0625rem;
  width: 100%;
`

export const LogoContainer = styled.div`
  margin-left: 0.75rem;
`
